<template>
    <div class="main">
        <div class="banner">
            <div class="banner-left">
                <div class="title">{{ $t('point.title') }}<br>{{ $t('point.title2') }}</div>
                <div class="content">{{ $t('point.describe') }}<br>
                {{ $t('point.describe2') }}</div>                   
            </div>
            <div class="banner-right">
                <img :src="require('../assets/server/peitu.png')" alt="" />
            </div>
        </div>
        <Board></Board>     
        <div class="container3">                       
     <div class="node">  
      <Node></Node>     
        </div> 
    <div class="globalpoint">
      <div class="search_box"> 
       <div style="display: flex; align-items: center; gap: 10px;">
            <div class="search">{{ $t('home.globalpoint.search_title') }}</div>
            <div class="search-icon" style="display: inline-block;"></div>
          </div>
        <div class="menu">
          <span class="menu-item">{{ $t('home.globalpoint.item1') }}</span>
          <span class="menu-item">{{ $t('home.globalpoint.item2') }}</span>
          <span class="menu-item">{{ $t('home.globalpoint.item3') }}</span>
         
        </div>
        <div class="table vote-scroll" style="margin: -25px auto 0 auto; height: 700px; width: 90%; overflow-y: auto; background-color: transparent; padding-right: 12px; scrollbar-gutter: stable;">
          <table style="width: 100%; height: 100%; border-collapse: collapse; font-family: '微软雅黑';">
            <tbody>
              <tr v-for="(item, index) in voteTop" :key="item.srAddress || index">
                <td :style="{ borderTop: index === 0 ? 'none' : '1px solid #ccc', borderBottom: '1px solid #ccc', borderLeft: 'none', borderRight: 'none', padding: '10px 20px 10px 70px', color: 'white', fontSize: '18px', width: '20%' }">
                  {{ index + 1 }}
                </td>
                <td :style="{ borderTop: index === 0 ? 'none' : '1px solid #ccc', borderBottom: '1px solid #ccc', borderLeft: 'none', borderRight: 'none', padding: '10px 10px 10px 190px', color: 'white', fontSize: '16px', width: '20%' }">
                  {{ item.srAddress }}
                </td>
                <td :style="{ borderTop: index === 0 ? 'none' : '1px solid #ccc', borderBottom: '1px solid #ccc', borderLeft: 'none', borderRight: 'none', padding: '10px 10px 10px 250px', color: 'white', fontSize: '16px', width: '40%' }">
                  {{ item.voteNum }}
                </td>
               
              </tr>
            </tbody>
          </table>
        </div>
      
      </div>
      <div class="title">{{ $t('home.globalpoint.title2') }}</div>
      <div style="position: absolute; color: white; right: 360px; top: 10px;font-size: 20px; cursor: pointer;" @click="openMiningRule">{{ $t('home.globalpoint.rule') }}→</div>  
      <div class="statistic-image" style="display: flex; justify-content: center; align-items: center; margin-top: 0;">
        <img :src="require('../assets/home/main_theme_accessories.png')" alt="主题装饰" >
      </div>    
    </div>
    </div>     
    <RedBook
      :show="showMiningRule"
      :book-type="'mining'"
      @showReceive="closeMiningRule"
    />
</div>   
</template>
<script>
import Board from '@/components/Board.vue';
import Node from './Node.vue'
import RedBook from '@/components/RedBook.vue'
import { voteRealPage } from '@/api';

export default {
    name: 'Server',
    components: { Board, Node, RedBook },
    data() {
        return {
            langue: localStorage.getItem('langue'),
            showMiningRule: false,
            voteTop: [] // 新增：投票排行榜数据
        }
    },
    created() {
        this.loadVoteTop(); // 新增：页面加载时获取投票榜数据
    },
    methods: {
        openMiningRule() {
            this.showMiningRule = true;
        },
        closeMiningRule() {
            this.showMiningRule = false;
        },
        // 新增：地址缩写（与 Home.vue / staking_mine.vue 保持一致）
        abbreviateAddress(addr) {
            if (!addr || typeof addr !== 'string') return '';
            const len = addr.length;
            if (len <= 10) return addr;
            return `${addr.slice(0, 5)}···${addr.slice(-5)}`;
        },
        // 新增：投票排行数据加载（与 Home.vue / staking_mine.vue 保持一致）
        async loadVoteTop() {
            try {
                const res = await voteRealPage();
                const list = res && res.data && Array.isArray(res.data)
                    ? res.data
                    : (res && res.data && res.data.data && Array.isArray(res.data.data) ? res.data.data : []);
                this.voteTop = list;
            } catch (e) {
                console.error('loadVoteTop failed:', e);
                this.voteTop = [];
            }
        }
    }
}
</script>






<style lang="scss" scoped>
.main {
  width: 100%;
  margin-top: 50px;

  .banner {
 
    width: 100%;
    min-width: 1200px;
    margin: 0 auto;
    height: 576px; /* 30vw ≈ 576px */
    margin-bottom: 0;
    padding-top: 50px;
    background-image: url("../assets/home/RWAbackground.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: relative;
    display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;

  .banner-left {
            flex: 1 1 auto;
            max-width: 1000px;
            text-align: left;
            z-index: 2;
            position: relative;
            left: 150px;
            top: -10px;
            /* 标题样式 */
            .title {
                color: #ffffff;
                font-size: 70px;
                font-weight: 700;
                line-height: 1.4;
                margin-bottom: 40px;
                font-family: 'Arial', sans-serif;
                max-width: 1600px;
            }
           
            /* 内容文本样式 */
            .content {
                font-family: 'Arial', sans-serif;
                font-size: 28px;
                font-weight: 400;
                color: #aaa9a9a2;
                max-width: 100%;
                line-height: 1.4;
            }
        }

        /* 横幅右侧图片区域 */
        .banner-right {
            top:50px;
            left:-50px;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10;
            position: relative;
            
            img {
                width: 100%;
                height: auto;
                scale: 0.9;
                
            }
        }
  }

  .container3 {
    background-image: url('../assets/background/background2.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
margin: 0 auto;
    width: 100%;
    
    margin: 0 auto;
    position: relative;
    height: 2631px; /* 137.44vw → 2631px */
  }

  .node {
    margin-top: -50px;

    .title {
      font-size: 44px;
      color: #fff;
      font-size: 700;
      font-family: emoji;
      font-weight: 600;
      text-align: center;
    }
  }

  .globalpoint {
      height: 1181px;
  
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 1920px;
     
    position: relative;
    left: 50%;
    transform: translateX(-50%);
     /* 61.5vw → 1181px */

    .title {
      font-family: "微软雅黑";
      color: #ece6e6;
      font-size: 50px;
      font-weight: 700;
      line-height: 1.2;
      margin-bottom: 0;
      font-family: "Arial", sans-serif;
      text-align: center;
      width: 100%;
    }

    .rule {
      font-size: 28px;
      font-weight: 400;
      color: #d31313cb;
      right: 100px;
    }

    .search_box {
      background-color: rgba(29, 28, 28, 0.76);
      width: 1210px;
      height: 885px;
      position: absolute;
      left: 360px;
      top: 150px;
      z-index: 10;

      .search {
        font-family: "微软雅黑";
        color: #6d6c6c;
        font-size: 18px;
        padding-left: 20px;
        width: 350px;
        padding-top: 10px;
        margin-top: -20px;
      }
    }

    .search-icon {
      width: 400px;
      height: 100px;
      scale: 1;
      margin-left: 650px;
      margin-top: 26px;
      font-size: 20px;
      color: #c2c2c280;
      text-align: center;
      padding-left: 50px;
      padding-top: 13px;
    }

    .menu {
      background-image: url("../assets/global/menu.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 93% 40%;
      width: 1200px;
      height: 100px;
      font-family: "微软雅黑";
      color: #000000;
      font-size: 18px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: -50px;
      font-weight: 600;
    }

    .menu-item {
      margin: 0 200px;
      width: auto;
      white-space: nowrap;
    }

   
  }
}

/* 投票表格滚动条美化（保留） */
:deep(.table.vote-scroll table td) {
  height: 65px;
  vertical-align: middle;
}

.table.vote-scroll {
  scrollbar-gutter: stable;
  color-scheme: dark;
  scrollbar-width: thin;
  scrollbar-color: rgba(140, 140, 140, 0.6) transparent;
}

:deep(.table.vote-scroll::-webkit-scrollbar) {
  width: 10px;
  background: transparent;
}
:deep(.table.vote-scroll::-webkit-scrollbar-track) {
  background: transparent !important;
}
:deep(.table.vote-scroll::-webkit-scrollbar-track-piece) {
  background: transparent !important;
}
:deep(.table.vote-scroll::-webkit-scrollbar-thumb) {
  background-color: rgba(140, 140, 140, 0.6);
  border-radius: 8px;
  border: 2px solid transparent;
}
:deep(.table.vote-scroll::-webkit-scrollbar-corner) {
  background: transparent !important;
}
</style>